<!--
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-06-19 18:00:11
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-14 17:19:18
-->
<template>
  <div class="footer">
    <div class="links"></div>
    <div class="copyright">Copyright &copy; 2024 平安行汽车服务有限公司</div>
  </div>
</template>

<script>
import version from "ant-design-vue/lib/version";
export default {
  name: "LayoutFooter",
  data() {
    return {
      version
    };
  }
};
</script>

<style lang="less" scoped>
.footer {
  padding: 0 16px;
  margin: 48px 0 24px;
  text-align: center;

  .links {
    margin-bottom: 8px;

    a {
      color: rgba(0, 0, 0, 0.45);

      &:hover {
        color: rgba(0, 0, 0, 0.65);
      }

      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }
  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/GlobalFooter.vue